import { Input, Select } from 'common/InputForm'
import { CustomModal } from 'components/modals/ModalBox'
import useButtonLoader from 'hooks/useButtonLoader'
import React, { useEffect, useState } from 'react'
import { updateDeliveryStatusApi, updateDeliveryValueApi } from 'services/masterApi'

const UpdateFreeDelivery = ({ show, close, data, listing = () => { } }) => {

    const [input, setInput] = useState({})
    const [error, setError] = useState({})
    const isUpdated = data?.type === 'Update'
    const [buttonLoader, setButtonLoader] = useButtonLoader(isUpdated ? 'Update' : 'Add');
    // console.log({ input, data })
    // subType: "MONTHLY"   subType: "DYNAMIC"   subType: "KILOMETER"
    // ---------validation-----------
    const validation = () => {
        let status = true;
        let errorMessage = {};
        if (data?.subType === "KILOMETER") {

            if (!input?.from) {
                errorMessage["from"] = "Please enter from";
                status = false;
            }
            if (!input?.to) {
                errorMessage["to"] = "Please enter to";
                status = false;
            }
        } else {

            if (!input?.value) {
                errorMessage["value"] = "Please enter value";
                status = false;
            }
            if (!input?.status) {
                errorMessage["status"] = "Please select status";
                status = false;
            }
        }

        setError(errorMessage);

        return status;
    };
    // -------modal-close------------
    const handleClose = () => {
        close()
        setError({})
        setInput({ name: '', subcategory: '' });
    }

    useEffect(() => {
        setInput(data)
    }, [data])


    // ------------submit---------------
    const handleSubmit = async () => {
        if (validation()) {
            const payload = {
                id: data?._id,
            }
            if (data?.subType === "KILOMETER") {
                payload.from = input?.from;
                payload.to = input?.to;
            } else {
                payload.value = input?.value;
                payload.status = input?.status;
            }
            try {
                if (setButtonLoader) {
                    setButtonLoader(true);
                }
                const res = await updateDeliveryValueApi(payload)

                const { code, message } = res?.data;
                if (code === 200) {
                    handleClose()
                    listing()
                }
            } catch (e) {
                console.log("error:", e.error);
            } finally {
                setButtonLoader(false);
            }
        }
    }
    return (
        <CustomModal
            className={"add_model"}
            show={show}
            handleClose={handleClose}
        >
            <h3>{data?.title}</h3>
            {data?.subType !== "KILOMETER" &&
                <>
                    <div className="form_field">
                        <Input
                            type="text"
                            label="Value"
                            placeholder="Value"
                            value={input?.value}
                            // onChange={(e) => update(v.id, "quantity", e.target.value)}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength={9}
                            onChange={(e) => {
                                let targetValue = e.target.value;
                                targetValue = targetValue.replace(/\s+/g, "");
                                if (/^\d*\.?\d{0,2}$/.test(targetValue)) {
                                    setInput({ ...input, value: targetValue });
                                }
                            }}
                            onKeyDown={(e) => {
                                if (["e", "E", "+", "-", "."].includes(e.key))
                                    e.preventDefault();
                            }}
                            error={error?.value}
                        />
                    </div>

                    <div className="form_field">
                        <Select
                            type="text"
                            label="Sub Category"
                            name="status"
                            value={input?.status}
                            onChange={(e) => setInput({ ...input, status: e.target.value })}
                            error={error.status}
                        >
                            <option value="">select Status</option>
                            <option value="ACTIVE">Active</option>
                            <option value="INACTIVE">InActive</option>
                        </Select>
                    </div>
                </>}
            {data?.subType === "KILOMETER" &&
                <>
                    <div className="form_field">
                        <Input
                            type="text"
                            label="From"
                            placeholder="from"
                            value={input?.from}
                            // onChange={(e) => update(v.id, "quantity", e.target.value)}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength={9}
                            onChange={(e) => {
                                let targetValue = e.target.value;
                                targetValue = targetValue.replace(/\s+/g, "");
                                if (/^\d*\.?\d{0,2}$/.test(targetValue)) {
                                    setInput({ ...input, from: targetValue });
                                }
                            }}
                            onKeyDown={(e) => {
                                if (["e", "E", "+", "-", "."].includes(e.key))
                                    e.preventDefault();
                            }}
                            error={error?.from}
                        />
                    </div>
                    <div className="form_field">
                        <Input
                            type="text"
                            label="To"
                            placeholder="to"
                            value={input?.to}
                            // onChange={(e) => update(v.id, "quantity", e.target.value)}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength={9}
                            onChange={(e) => {
                                let targetValue = e.target.value;
                                targetValue = targetValue.replace(/\s+/g, "");
                                if (/^\d*\.?\d{0,2}$/.test(targetValue)) {
                                    setInput({ ...input, to: targetValue });
                                }
                            }}
                            onKeyDown={(e) => {
                                if (["e", "E", "+", "-", "."].includes(e.key))
                                    e.preventDefault();
                            }}
                            error={error?.to}

                        />
                    </div>
                </>}
            <div className="button_wrap">
                <button
                    type="button"
                    className="button light"
                    onClick={handleClose}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    ref={buttonLoader}
                    onClick={handleSubmit}
                    className="button"
                >
                    {isUpdated ? 'Update' : 'Add'}
                </button>
            </div>
        </CustomModal>
    )
}

export default UpdateFreeDelivery